import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SerialNumbers_ds_child_serialnumbers_gridService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { chainHead: number, archived?: boolean, fullTextSearch?: string }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LookupCode?: string, NetVolume?: number, NetWeight?: number, Notes?: string, Width?: number, Lot?: { Id?: number, LookupCode?: string, Material?: { Id?: number, LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string } }, VendorLot?: { LookupCode?: string } }, LicensePlate?: { Id?: number, LookupCode?: string, Location?: { Id?: number, Name?: string, Warehouse?: { Name?: string } }, Type?: { Name?: string } }, Status?: { Name?: string }, DimensionsUom?: { Short_name?: string }, WeightUom?: { Short_name?: string }, VolumeUom?: { Short_name?: string }, Packaging?: { ShortName?: string }, OutboundShipment?: { LookupCode?: string, Status?: { Name?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.chainHead)) {
      missingRequiredInParams.push('\'chainHead\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_child_serialnumbers_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { chainHead: number, archived?: boolean, fullTextSearch?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LookupCode?: string, NetVolume?: number, NetWeight?: number, Notes?: string, Width?: number, Lot?: { Id?: number, LookupCode?: string, Material?: { Id?: number, LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string } }, VendorLot?: { LookupCode?: string } }, LicensePlate?: { Id?: number, LookupCode?: string, Location?: { Id?: number, Name?: string, Warehouse?: { Name?: string } }, Type?: { Name?: string } }, Status?: { Name?: string }, DimensionsUom?: { Short_name?: string }, WeightUom?: { Short_name?: string }, VolumeUom?: { Short_name?: string }, Packaging?: { ShortName?: string }, OutboundShipment?: { LookupCode?: string, Status?: { Name?: string } } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.chainHead)) {
      missingRequiredInParams.push('\'chainHead\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_child_serialnumbers_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { chainHead: number, archived?: boolean, fullTextSearch?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, GrossVolume?: number, GrossWeight?: number, Height?: number, Length?: number, LookupCode?: string, NetVolume?: number, NetWeight?: number, Notes?: string, Width?: number, Lot?: { Id?: number, LookupCode?: string, Material?: { Id?: number, LookupCode?: string, ProjectId?: number, Project?: { LookupCode?: string } }, VendorLot?: { LookupCode?: string } }, LicensePlate?: { Id?: number, LookupCode?: string, Location?: { Id?: number, Name?: string, Warehouse?: { Name?: string } }, Type?: { Name?: string } }, Status?: { Name?: string }, DimensionsUom?: { Short_name?: string }, WeightUom?: { Short_name?: string }, VolumeUom?: { Short_name?: string }, Packaging?: { ShortName?: string }, OutboundShipment?: { LookupCode?: string, Status?: { Name?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.chainHead)) {
      missingRequiredInParams.push('\'chainHead\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_child_serialnumbers_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      chainHead: number, archived?: boolean, fullTextSearch?: string    }) {
        if(isNil(inParams.chainHead)) {
          return true; 
        }
      return false;
    }
}
